<template>
  <div class="overlay">
    <div class="callout secondary text-center padding-2">
      <h5>{{ $t('AssemblyUnavailableOverlay.title') }}</h5>
      <p v-html="$t('AssemblyUnavailableOverlay.description')" />
    </div>
  </div>
</template>

<script>
import messages from 'locales/AssemblyUnavailableOverlay';

export default {
  name: 'AssemblyUnavailableOverlay',
  i18n: { messages },
};
</script>

<style scoped lang="scss">
.overlay {
  position: absolute;
  height: 100%;
  background-color: #ffffff99;
  z-index: 100;

  display: flex;
  padding: 5rem;
  flex-direction: column;
  justify-content: center;
}
</style>
